export enum HeatingCategory {
  Individual_Boiler,
  Timer,
  Titration_Calorimeter,
  Central_Heating,
}
